import { useEffect, useState } from 'react'

type IconProps = React.ComponentProps<'svg'> & {
  value: 'ai'
}

function Icon({ value, ...props }: IconProps) {
  const [SvgComponent, setSvgComponent] = useState<React.FC<React.SVGProps<SVGSVGElement>>>()

  useEffect(() => {
    const loadSvg = async () => {
      try {
        const svgModule = await import(`./${value}.svg?react`)
        setSvgComponent(() => svgModule.default)
      } catch {
        //
      }
    }

    loadSvg()
  }, [value])

  if (!SvgComponent) {
    return null
  }

  return <SvgComponent {...props} />
}

export { Icon }
